/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseNewBlogPostFragment} from '@amblique/contentful/app/contentful/fragments/new-blog-post/base-new-blog-post.fragment';

export const FullNewBlogPostFragment = gql`
  ${BaseNewBlogPostFragment}

  fragment FullNewBlogPostFragment on NewBlogPost {
    ...BaseNewBlogPostFragment

    relatedPostsCollection {
      items {
        __typename
        ... on Entry {
          sys {
            id
          }
        }
      }
    }
  }
`;
